// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2aJJQ","topBottomGutter":"Layout_topBottomGutter__3F1P5"};